/**
*
*   Stockist form
*       - A Stockist Signup / Inquiry Form
*
**/
'use client';

import Button from '@/components/button';
import Storefront from '@/libraries/shopify/class';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';


//Build the Element
export default function RecoverPassword(){

	const { control, register, setError, formState: { errors, isSubmitting, isSubmitSuccessful }, handleSubmit } = useForm();
	const [ status , setStatus ] = useState(false);
	const [ loading , setLoading ] = useState(false);
	const t = useTranslations();

	//Form Settings
	const Form = {

		//Settings
		email: {
			validate: email => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email) || t('Forms.Errors.email.invalid') //eslint-disable-line no-useless-escape
		},

		//Error
		error: ({ message }) =>(<p className="error">{ message }</p> ),

		//A Thrown Error Message
		thrown: ( message ) => setError('root.serverError',{
			type: 500,
			message: `${ t('errors.unknown')  } ${  message }`
		}),

		//On Submit
		submit: async data => {
			setLoading(true);

			//Initiate the reset
			const reset = await Storefront.Customer.password.recover(data.email);

			//Stop Loading
			setLoading(false);

			//If we have errors
			if( !reset.result )
				return setError('root.serverError',{
					type: 500,
					message: reset.errors.map( (e,i) => (<p key={i}>{ e.message }</p>) )
				});

			//Success
			setStatus(true);
		}
	};

	return (
		<form id="reset-password-form" onSubmit={ handleSubmit(Form.submit) }>{
			status ? (
				<div id="reset-password-form">
					<p className="success">{ t('Pages.Recover.success') }</p>
				</div>
			) : (
				<>
					{/* Submission Response Error */}
					{ errors.root?.serverError?.type > 200 && (
						<div className="failed">{
							errors.root.serverError.message
						}</div>
					) }

					{/* Row1 */}
					<div className="row">
						<div>
							<label htmlFor="email">{ t('Forms.Labels.email') }</label>
							<input name="email" placeholder={ `${ t('Forms.Labels.email')  }*` } {...register('email', { required: t('Forms.Errors.required',{ type: t('Forms.Labels.email') }), validate: Form.email.validate })} />
							<ErrorMessage errors={errors} name="email" render={ Form.error } />
						</div>
					</div>

					{/* Submit */}
					<div className="row submit">
						<div>
							<Button disabled={ isSubmitting || loading } button type="submit">{ t('Navigation.sign-in') }</Button>
						</div>
					</div>
				</>
			)
		}</form>
	);

}